import { render, staticRenderFns } from "./LeaveTypes.vue?vue&type=template&id=5651632a&scoped=true&"
import script from "./LeaveTypes.vue?vue&type=script&lang=js&"
export * from "./LeaveTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651632a",
  null
  
)

export default component.exports